import { useHttp } from '@/api'
import { httpApi } from '@/api/api'

/**
 * 検索運送一覧情報
 */
export function searchTransBasic(data, callBackFn) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.SearchTransBasic, data)
      .then(res => {
        resolve(res)
        callBackFn()
      })
      .catch(err => {
        reject(err)
      })
  })
}
/**
 * 削除運送一覧情報
 */
export function deleteTransBasicByTransNo(data, callBackFn) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.DeleteTransBasicByTransNo, data)
      .then(res => {
        resolve(res)
        callBackFn()
      })
      .catch(err => {
        reject(err)
      })
  })
}
/**
 * 運送一覧：検索条件リストの初期化(状態)
 */
export function initTransSearchList(data, callBackFn) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.InitTransSearchList, data)
      .then(res => {
        resolve(res)
        callBackFn()
      })
      .catch(err => {
        reject(err)
      })
  })
}
/**
 * 運送一覧：基本情報のリスト取得（輸送方式、担当者）
 */
export function getTransInitList(data, callBackFn) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.GetTransInitList, data)
      .then(res => {
        resolve(res)
        callBackFn()
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 運送明細：運送No.によると、運送基本情報と明細情報の検索
 */
export function searchTransDetailByTransNo(data, callBackFn) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.SearchTransDetailByTransNo, data)
      .then(res => {
        resolve(res)
        callBackFn()
      })
      .catch(err => {
        reject(err)
      })
  })
}
/**
 * 運送製品選択画面：情報の検索
 */
export function searchTransSelectInfo(data, callBackFn) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.SearchTransSelectInfo, data)
      .then(res => {
        resolve(res)
        callBackFn()
      })
      .catch(err => {
        reject(err)
      })
  })
}
/**
 * 運送明細：運送No.によると、運送基本情報と明細情報の更新
 */
export function updateTransDetail(data, callBackFn) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.UpdateTransDetail, data)
      .then(res => {
        resolve(res)
        callBackFn()
      })
      .catch(err => {
        reject(err)
      })
  })
}
/**
 * 運送明細：運送基本情報と明細情報の新規追加
 */
export function addTransDetail(data, callBackFn) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.AddTransDetail, data)
      .then(res => {
        resolve(res)
        callBackFn()
      })
      .catch(err => {
        reject(err)
      })
  })
}
/**
 * 運送明細：運送基本情報と明細情報の新規追加
 */
export function getTransSelectData(data, callBackFn) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.GetTransSelectData, data)
      .then(res => {
        resolve(res)
        callBackFn()
      })
      .catch(err => {
        reject(err)
      })
  })
}


